export enum AudioType {
    /** Audio from a voice talent. */
    ttp = 'voice-talent',
    /** Audio from a text-to-speech service. */
    tts = 'tts'
}
